<template>
  <div>
    <page-breadcrumb title="Graph" :routes="routes" />
    <vx-card>
      <div class="in-out-info mb-8">
        <div class="box">
          <div class="title">IN</div>
          <div class="value">{{ Math.abs(totalIn) }}</div>
        </div>
        <div class="box">
          <div class="title">OUT</div>
          <div class="value">{{ Math.abs(totalOut) }}</div>
        </div>
      </div>
      <div class="vx-row">
        <div
          v-for="(chart, idx) in charts"
          :key="idx"
          class="vx-col w-full mb-8 md:w-1/2 lg:w-1/2 xl:w-1/2"
        >
          <div class="title">{{ chart.name }}</div>
          <vue-apex-charts
            height="350"
            :options="chart.chartOptions"
            :series="chart.chart.series"
          ></vue-apex-charts>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import PageBreadcrumb from "../components/PageBreadcrumb.vue";
import api from "../api";

export default {
  data() {
    return {
      charts: [],
    };
  },
  computed: {
    site() {
      return this.$store.state.sites;
    },
    currentSite() {
      return this.$store.state.currentSite;
    },
    routes() {
      return {
        ...this.$route,
        meta: {
          ...this.$route.meta,
          breadcrumb: [
            { title: "Dashboard", url: "/" },
            {
              title: this.currentSite.name,
              url: "/site/" + this.currentSite.id,
            },
            { title: "Graph", active: true },
          ],
        },
      };
    },
    totalIn() {
      let tsIn = 0;
      this.charts.map((y) => {
        tsIn += y.chart.series[0].data.reduce((a, b) => a + b, 0);
      });
      return tsIn;
    },
    totalOut() {
      let tsOut = 0;
      this.charts.map((y) => {
        tsOut += y.chart.series[1].data.reduce((a, b) => a + b, 0);
      });
      return tsOut;
    },
  },
  components: {
    VueApexCharts,
    PageBreadcrumb,
  },
  created() {
    this.$vs.loading();
  },
  beforeMount() {
    const currentSite = this.site.find((v) => v.id == this.$route.params.slug);
    this.$store.dispatch("updateCurrentSite", currentSite);
  },
  mounted() {
    this.getGraphData();
  },
  methods: {
    getGraphData() {
      api
        .graphData({ SiteId: this.currentSite.id })
        .then((result) => result.data.data)
        .then((data) => {
          data.map((x) => {
            const chart = {
              ...x,
              chartOptions: {
                colors: ["#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
                plotOptions: {
                  bar: {
                    horizontal: false,
                    endingShape: "rounded",
                    columnWidth: "30%",
                  },
                },
                dataLabels: {
                  enabled: false,
                },
                stroke: {
                  show: true,
                  width: 2,
                  colors: ["transparent"],
                },
                chart: {
                  stacked: true,
                  type: "bar",
                  toolbar: { show: false },
                },
                xaxis: {
                  categories: x.chart.categories,
                },
                yaxis: {
                  title: {
                    text: "Unit",
                  },
                },
                fill: {
                  opacity: 1,
                },
                tooltip: {
                  y: {
                    formatter: function (val) {
                      return Math.abs(val);
                    },
                  },
                },
              },
            };
            this.charts.push(chart);
          });
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18pt;
  text-align: center;
  font-weight: 700;
}
.in-out-info {
  display: flex;
  justify-content: center;
  .box {
    width: 200px;
    border: 1px solid #dddddd;
    text-align: center;
    border-radius: 10px;
    padding: 10px;
    .title {
      color: #d71b1b;
      font-weight: 700;
      font-size: 18pt;
    }
    .value {
      font-size: 24pt;
    }
    &:first-child {
      margin-right: 20px;
      .title {
        color: #0cb51d;
      }
    }
  }
}
</style>
